import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Image, Placeholder } from "semantic-ui-react";

@observer
class ImageWithLoading extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
    };
  }

  onLoad() {
    this.setState({ loading: true });
  }

  render() {
    const { src, size, width, height, onClickCallback } = this.props;
    const { loading } = this.state;

    return (
      <div>
        {!loading ? (
          <Placeholder style={{ width, height }}>
            <Placeholder.Image rectangular />
          </Placeholder>
        ) : null}
        <Image
          bordered
          rounded
          src={src}
          style={!loading ? { display: "none" } : {}}
          onLoad={() => this.onLoad()}
          size={size}
          onClick={() => {
            if (typeof onClickCallback === "function") {
              onClickCallback();
            }
          }}
        />
      </div>
    );
  }
}

ImageWithLoading.propTypes = {
  src: PropTypes.string.isRequired,
  size: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  onClickCallback: PropTypes.func,
};

ImageWithLoading.defaultProps = {
  size: "small",
  width: "auto",
  height: "auto",
};

export default ImageWithLoading;
